export default __webpack_public_path__ + "static/media/ser6.64a08fb4.svg";